import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import useRepeatOrder from "./useRepeatOrder";
import SendExcelData from "../../Admin/OrderList/SendExcelData";
import CustomDateRangePicker from "../../Global/CustomDateRangePicker";

const RepeatOrder = () => {
  const {
    date,
    isLoading,
    isFetching,
    showEditModal,
    isExcelLinkSend,
    repeatOrderList,
    repeatOrderState,
    paginationOptions,
    handleRepeatOrderExcelDownload,
    handleEditColumnsClick,
    updateRepeatOrderFields,
    handleDateRangeChange,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    sendExcelData,
    handleSort,
    modalClose,
    refetch,
    getRow,
  } = useRepeatOrder();
  return (
    <>
      <HeadingGroup title="Repeat Order" className={`pro-mb-4`}>
        <div className="col dropdown-filter pro-d-flex">
          <button
            className={`pro-btn pro-btn-outline-primary no-wrap pro-items-center pro-ms-3`}
            type="submit"
            onClick={handleRepeatOrderExcelDownload}
          >
            <span className="material-symbols-outlined x4">download</span>
            <span>{`Repeat Order Data`}</span>
          </button>
        </div>
      </HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={repeatOrderState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: repeatOrderState?.search }}
          handleActionClick={handleEditColumnsClick}
          searchable={false}
          dropDownFilter={
            <>
              <div className="col-auto">
                <CustomDateRangePicker
                  defaultDateRange={date}
                  handleDateRangeChange={handleDateRangeChange}
                />
              </div>
            </>
          }
          onDateChange={handleDateChange}
          initialDateRange={date}
        />
        {repeatOrderList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={repeatOrderList?.data?.result || []}
            uniqueID={"id"}
            fields={repeatOrderList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={repeatOrderState?.clearSelection}
            perpage={repeatOrderState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}

        {repeatOrderList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={repeatOrderState?.currentPage}
            totalPageCount={Math.ceil(
              repeatOrderList?.data.total_count /
                repeatOrderState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === repeatOrderState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={repeatOrderList?.data?.fields || []}
              moduleId={repeatOrderList?.data?.module_id}
              updateData={updateRepeatOrderFields}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={repeatOrderState.repeatOrderExcelSendModal}
          handleClose={handleRepeatOrderExcelDownload}
          title={`Send Excel Download Link`}
          backdrop="static"
        >
          <div className="pro-m-5">
            <SendExcelData
              isBestSeller
              handleCloseModal={modalClose}
              sendExcelData={sendExcelData}
              isExcelLinkSend={isExcelLinkSend}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default RepeatOrder;
